import { Link } from "react-router-dom";

import { useKeepRelevantParams } from "../../SecondarySidebar/Content/hooks/useKeepRelevantParams";

import { useUser } from "@/context/user-context";

export const NavigationLink = ({
  to,
  children,
  className,
  ...props
}: {
  to: string;
  children: React.ReactNode;
  className?: string;
} & React.HTMLAttributes<HTMLElement>) => {
  const keepRelevantParams = useKeepRelevantParams();
  const userContext = useUser();

  // Check if the URL is external (starts with http/https)
  const isExternal = to.startsWith("http://") || to.startsWith("https://");

  if (isExternal) {
    return (
      <a href={to} target="_blank" rel="noopener noreferrer" className={className} {...props}>
        {children}
      </a>
    );
  }

  // Transform /folder/:folderId paths to /home
  const transformedTo = to.replace(/^folder\/[^/]+/, "home");

  // For internal links, construct the full path with workspace
  const fullPath = `/workspace/${userContext?.activeWorkspace?.id}/${transformedTo}`;
  const searchParams = keepRelevantParams();

  return (
    <Link to={{ pathname: fullPath, search: searchParams }} className={className} {...props}>
      {children}
    </Link>
  );
};
